import { ArchBaseService } from "@/common/api.service";

const API_BASE = "admin/config";

const state = {
  documentRequirements: [],
  documentTypes: [],
  businessTypes: [],
  countries: [],
  isLoading: false,
  error: null,
};

const getters = {
  documentRequirements: (state) => state.documentRequirements,
  documentTypes: (state) => state.documentTypes,
  businessTypes: (state) => state.businessTypes,
  configCountries: (state) => state.countries,
  configIsLoading: (state) => state.isLoading,
  configError: (state) => state.error,
};

const mutations = {
  SET_DOCUMENT_REQUIREMENTS(state, data) {
    state.documentRequirements = data;
  },
  SET_DOCUMENT_TYPES(state, data) {
    state.documentTypes = data;
  },
  SET_BUSINESS_TYPES(state, data) {
    state.businessTypes = data;
  },
  SET_COUNTRIES(state, data) {
    state.countries = data;
  },
  SET_CONFIG_LOADING(state, val) {
    state.isLoading = val;
  },
  SET_CONFIG_ERROR(state, val) {
    state.error = val;
  },
};

const actions = {
  async fetchDocumentRequirements({ commit }, params = {}) {
    ArchBaseService.init();
    commit("SET_CONFIG_LOADING", true);
    commit("SET_CONFIG_ERROR", null);
    try {
      const response = await ArchBaseService.get(`${API_BASE}/document-requirements`, params);
      commit("SET_DOCUMENT_REQUIREMENTS", response.data.details || []);
      return response.data.details;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_CONFIG_ERROR", msg);
      throw error;
    } finally {
      commit("SET_CONFIG_LOADING", false);
    }
  },

  async createDocumentRequirement({ commit }, payload) {
    ArchBaseService.init();
    try {
      const response = await ArchBaseService.post(`${API_BASE}/document-requirements`, payload);
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_CONFIG_ERROR", msg);
      throw error;
    }
  },

  async updateDocumentRequirement({ commit }, { id, payload }) {
    ArchBaseService.init();
    try {
      const response = await ArchBaseService.put(`${API_BASE}/document-requirements/${id}`, payload);
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_CONFIG_ERROR", msg);
      throw error;
    }
  },

  async deleteDocumentRequirement({ commit }, id) {
    ArchBaseService.init();
    try {
      const response = await ArchBaseService.destroy(`${API_BASE}/document-requirements/${id}`);
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_CONFIG_ERROR", msg);
      throw error;
    }
  },

  async createDocumentType({ commit }, payload) {
    ArchBaseService.init();
    try {
      const response = await ArchBaseService.post(`${API_BASE}/document-types`, payload);
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_CONFIG_ERROR", msg);
      throw error;
    }
  },

  async updateDocumentType({ commit }, { id, payload }) {
    ArchBaseService.init();
    try {
      const response = await ArchBaseService.put(`${API_BASE}/document-types/${id}`, payload);
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_CONFIG_ERROR", msg);
      throw error;
    }
  },

  async fetchDocumentTypes({ commit }) {
    ArchBaseService.init();
    try {
      const response = await ArchBaseService.get(`${API_BASE}/document-types`);
      const items = (response.data.details || []).map((item) => item.dataValues || item);
      commit("SET_DOCUMENT_TYPES", items);
      return response.data.details;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_CONFIG_ERROR", msg);
      throw error;
    }
  },

  async fetchBusinessTypes({ commit }) {
    ArchBaseService.init();
    try {
      const response = await ArchBaseService.get(`${API_BASE}/business-types`);
      const items = (response.data.details || []).map((item) => item.dataValues || item);
      commit("SET_BUSINESS_TYPES", items);
      return response.data.details;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_CONFIG_ERROR", msg);
      throw error;
    }
  },

  async fetchCountries({ commit }) {
    ArchBaseService.init();
    try {
      const response = await ArchBaseService.get(`${API_BASE}/countries`);
      const items = (response.data.details || []).map((item) => item.dataValues || item);
      commit("SET_COUNTRIES", items);
      return response.data.details;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_CONFIG_ERROR", msg);
      throw error;
    }
  },

  async updateCountry({ commit }, { countryId, payload }) {
    ArchBaseService.init();
    try {
      const response = await ArchBaseService.put(`${API_BASE}/countries/${countryId}`, payload);
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_CONFIG_ERROR", msg);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
